import request from '@/utils/request';
//活动分页
export function getActivityList(values) {
  return request('/activityLottery/queryActivityList', {
    method: 'POST',
    data: values,
  });
}
//删除活动
export function activityDelete(values) {
  return request('/activityLottery/delete', {
    method: 'POST',
    data: values,
  });
}
//修改概率
export function changeHitRate(values) {
  return request('/activityLottery/changeHitRate', {
    method: 'POST',
    data: values,
  });
}
//终止活动
export function activityPause(values) {
  return request('/activityLottery/terminate', {
    method: 'POST',
    data: values,
  });
}
